// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/mission-launch/shared/AnimatedProgressStrip.jsx

import React from 'react';

export default function AnimatedProgressStrip({ value = 0, label = 'Mission progress' }) {
  const normalized = Math.max(0, Math.min(100, Number(value) || 0));
  return (
    <div className="animated-progress-strip" style={{ '--progress': `${normalized}%` }}>
      <div className="animated-progress-strip-header">
        <span>{label}</span>
        <strong>{normalized}%</strong>
      </div>
      <div className="animated-progress-track"><span /></div>
    </div>
  );
}
